import { useLazyQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import FileUpload from '../../components/Popups/FileUpload';
import { DELETE_EBOOK_MATERIAL, DELETE_EBOOK_MATERIAL_ADMIN, UPDATE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL_ADMIN, UPLOAD_MATERIAL_ADMIN, VIEW_ALL_MATERIAL_ADMIN } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import './QuestionBank.scss';
import { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import ViewPage from '../../components/ViewPage/ViewPage';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import ToasterWithMessage from '../../components/toaster';
import { useAppSelector } from '../../redux/app/hooks';
import QuestionBankList from '../../components/QuestionBankList/QuestionBankList';
import { materialsData } from '../../utils/interface';
import { CLASSROOM_S3_PATH, FETCH_POLICY, PATH_ADDRESSES, QUESTION_BANK_TEXT, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { GET_ALL_QUESTIONS_BANK, UPLOAD_QUESTIONS_BANK, UPLOAD_QUESTIONS_BANK_ADMIN, VIEW_ALL_MATERIAL_ADMIN_QUESTION_BANK } from './api/QuestionsBankQuery';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getScreenDimensions } from '../../utils/helper';
import { EDIT_QUESTION_BANK_MATERIALS } from '../ImageMaterial/api/ImageMaterialQuery';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';

const QuestionBank = () => {
    const { CloudDownload, uploadCloud } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [qsBankUrl, setQsBankUrl] = useState<string>();
    const [qsBankFilename, setQsBankFilename] = useState<string>();
    const [qsBankCsvFileData, setQsBankCsvFileData] = useState<any>(); //Need to change
    const [qsBankFileData, setQsBankFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [qsBankOpen, setQsBankOpen] = useState<boolean>(false);
    const [qsBankOpenCsv, setQsBankOpenCsv] = useState(false); //Need to change
    const [questionBankData, setQuestionBankData] = useState<[materialsData]>();
    const [singleQuestionBankData, setSingleQuestionBankData] = useState<materialsData | undefined>();
    const [qsBankUploadProgress, setQsBankUploadProgress] = useState(0);
    const [materialAction,setMaterialAction] = useState<string>('');
    const [qsBankUploadFailed, setQsBankUploadFailed] = useState<boolean>(false);
    const [qsBankUploadFileName, setQsBankUploadFileName] = useState<string>('');
    const [qsBankUploaded, setQsBankUploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const [subCategory, setSubCategory] = useState<string>('Questions Bank');
    const backNavigation = role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const baseURL = process.env.REACT_APP_FRONTEND_URL;
    const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );

    const [isEditQuestionBank, setIsEditQuestionBank] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [editQuestionBank] = useMutation(EDIT_QUESTION_BANK_MATERIALS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log("edit question bank data",data);
           if(data?.editQuestionBanks) {
                setQsBankFileData(null);
                if(!(qsBankFileData && qsBankUrl)) {
                    success("File updated successfully!");
                }
                if(qsBankFileData && qsBankUrl) {
                    if (qsBankFilename) {
                        setQsBankUploadFileName(qsBankFilename);
                    }
                    setQsBankUploaded(true);
                    setQsBankUploadProgress(100);
                }
                setQsBankFilename('');
                setQsBankUrl('');
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                if(role === SCHOOL_ADMIN){
                    getAllQuestionBankAdmin({
                   variables: {
                     input: {
                       sjId: selectedSubjectId,
                       cIds: [selectedClassroomIdAdmin],
                     },
                   },
                 });
                } else {
                    getAllQuestionBank({
                        variables: {
                            input: {
                                sjId: selectedSubjectId,
                                cId: selectedClassRoomId,
                                limit: null,
                                offset: null,
                            }
                        }
                    })
                }
           }
        },
        onError: (err) => {
            error(err?.message);
            if (qsBankFilename) {
                setQsBankUploadFileName(qsBankFilename);
            }
            if(qsBankFileData && qsBankUrl) {
                setQsBankUploaded(true);
                setQsBankUploadProgress(0);
                setQsBankUploadFailed(true);
            }
        }
    });
    
    const [getAllQuestionBank, { loading }] = useLazyQuery(GET_ALL_QUESTIONS_BANK, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getAllQuestionBanks?.allquestionbanks) {
                setQuestionBankData(data?.getAllQuestionBanks?.allquestionbanks);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

     const [getAllQuestionBankAdmin, {loading : AdminLoading } ] = useLazyQuery(VIEW_ALL_MATERIAL_ADMIN_QUESTION_BANK, {
         fetchPolicy: FETCH_POLICY,
             onCompleted: (data) => {
                 if (data?.getAllQuestionBanks?.allquestionbanks) {
                     setQuestionBankData(data?.getAllQuestionBanks?.allquestionbanks);
                 }
             },
             onError: (err) => {
                 error(err?.message);
                 console.error(err?.message)
             }
         }) 


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(questionBankData && questionBankData.length > 0){
        questionBankData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[profile?.getCurrentUser?.nodes, questionBankData, readFeed, role])

    const [uploadQuestionBank] = useMutation(UPLOAD_QUESTIONS_BANK, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadQuestionBanks) {
                setQsBankFileData(null);
                if (qsBankFilename) {
                    setQsBankUploadFileName(qsBankFilename);
                }
                setQsBankUploaded(true);
                setQsBankUploadProgress(100);
                setQsBankFilename('');
                setQsBankUrl('');
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            if (qsBankFilename) {
                setQsBankUploadFileName(qsBankFilename);
            }
            error(err?.message);
            setQsBankUploaded(true);
            setQsBankUploadProgress(0);
            setQsBankUploadFailed(true);
        }
    });

    const [uploadQuestionBankAdmin] = useMutation(UPLOAD_QUESTIONS_BANK_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadQuestionBanksByAdmin) {
                setUploadedPayloads([]);

                const result = data.uploadQuestionBanksByAdmin?.result || [];

                setUploadResults(result);

                const hasFailures = result.some(
                    (res: UploadResult) => res.classroomsFailed && res.classroomsFailed.length > 0
                );

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setQsBankFileData(null);
                if (qsBankFilename) {
                    setQsBankUploadFileName(qsBankFilename);
                }
                setQsBankUploaded(true);
                setQsBankUploadProgress(100);
                setQsBankFilename('');
                setQsBankUrl('');
                 getAllQuestionBankAdmin({
                   variables: {
                     input: {
                       sjId: selectedSubjectId,
                       cIds: [selectedClassroomIdAdmin],
                     },
                   },
                 });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (qsBankFilename) {
                setQsBankUploadFileName(qsBankFilename);
            }
            error(err?.message);
            setQsBankUploaded(true);
            setQsBankUploadProgress(0);
            setQsBankUploadFailed(true);
        }
    });

    const [updateQuestionBank] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


    const [updateQuestionBankAdmin] = useMutation(UPDATE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.updateEbookMaterialsBySchoolAdmin) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllQuestionBankAdmin({
                   variables: {
                     input: {
                       sjId: selectedSubjectId,
                       cIds: [selectedClassroomIdAdmin],
                     },
                   },
                 });
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [deleteQuestionBank] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

     const [deleteQuestionBankAdmin] = useMutation(DELETE_EBOOK_MATERIAL_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.deleteEbookMaterialsBySchoolAdmin) {
                success("Deleted successfully");
                getAllQuestionBankAdmin({
                   variables: {
                     input: {
                       sjId: selectedSubjectId,
                       cIds: [selectedClassroomIdAdmin],
                     },
                   },
                 });
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    useEffect(() => {
        if(role === SCHOOL_ADMIN){
        getAllQuestionBankAdmin({
          variables: {
            input: {
              sjId: selectedSubjectId,
              cIds: [selectedClassroomIdAdmin],
            },
          },
        });
        }else{
        getAllQuestionBank({
            variables: {
                input: {
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    limit: null,
                    offset: null,
                }
            }
        });
    }
    }, []);


    
    useEffect(() => {
        if(materialAction === 'edit' && (hasSubmittedForEdit)) {
            console.log("ready to call the edit api", qsBankFileData, qsBankFilename, qsBankUrl);
            let newFileName;
            let newFilePath;
            let newFileSize;

            if(qsBankFilename !== singleQuestionBankData?.filename){
                newFileName = qsBankFilename?.replace(/\.csv$/, "")?.trim();
            }
            if(qsBankUrl && qsBankFileData) {
                newFilePath = qsBankUrl;
                newFileSize = qsBankFileData?.size;
            }
            editQuestionBank({
                variables: {
                    fileId: singleQuestionBankData?.fileId,
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassRoomId,
                    subjectId: selectedSubjectId,
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize })
                }
            })
        }
    }, [qsBankFileData, qsBankFilename, qsBankUrl]);


    const formatUploadedPayloads = (
        uploadedPayloads: UploadedFilePayload[]
        ) => {
    
      return uploadedPayloads.map((item) => {
        return {
            filename: item.filename?.replace(/\.csv$/, "")?.trim(),
            filepath: item.filepath,
            filesize: item.filesize,
            isClassroom: false
        };
        });
        };
    
        useEffect(() => {
            if(uploadedPayloads.length > 0 ){
                const updatedFormattedPayload = formatUploadedPayloads(
                    uploadedPayloads
                );
    
                if(role === SCHOOL_ADMIN){
                    uploadQuestionBankAdmin({
                        variables: {
                            files: updatedFormattedPayload,
                            classroomIds: [selectedClassroomIdAdmin],
                            subjectId: selectedSubjectId
                        }
                    });
                } else if(role === TEACHER_ROLE) {
                    uploadQuestionBank({
                        variables: {
                            classroomId: selectedClassRoomId,
                            subjectId: selectedSubjectId,
                            files: updatedFormattedPayload
                        }
                    });
                }
            }
        }, [ uploadedPayloads ]);

    //To open csv in detailed view
    const handleOpenFile = (pdfData: materialsData) => {
        console.log(pdfData, "pdfdata")
        setSubCategory(`Questions Bank / ${pdfData?.filename}`);
        const setState = { ...state, isQuestionBank: true, data: pdfData, backNavigation: { path: '/student-classroom/ebooks/materials/question-bank', state: state } }
        setQsBankCsvFileData(pdfData);
        if ( role === STUDENT_ROLE ) {
            if (pdfData?.status !== "COMPLETED") {
                navigate('/student-classroom/question-bank/test', { 
                    state: setState
                });
            }
            else {
                navigate('/student-classroom/question-bank/view', { 
                    state: setState
                });
            }
        }
        else if(role === TEACHER_ROLE){
            setQsBankOpenCsv(true);
        }
        else if(role === SCHOOL_ADMIN){
            setQsBankOpenCsv(true);
        }
    }

    //To close csv detailed view
    const handleCloseCsv = () => {
        setQsBankOpenCsv(false);
        setQsBankCsvFileData(undefined);
    }

    //To done actions in materials
    const handleMaterialActions = (data: materialsData, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
             if(role === SCHOOL_ADMIN){
                updateQuestionBankAdmin({
                   variables: {
                     input: {
                        pSubjectId: selectedSubjectId,
                        pFileId: data?.fileId,
                        pIsClassroom: true,
                        pTypeName: QUESTION_BANK_TEXT,
                        pClassroomIds: [selectedClassroomIdAdmin],
                    },
                    },
                    });
                }else{
            updateQuestionBank({
                variables: {
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: QUESTION_BANK_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
            if(role === SCHOOL_ADMIN){
              updateQuestionBankAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pTypeName: QUESTION_BANK_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateQuestionBank({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: QUESTION_BANK_TEXT,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }
        } else if (action === "delete") {
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
              deleteQuestionBankAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pTypeName: QUESTION_BANK_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            deleteQuestionBank({
                variables: {
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: QUESTION_BANK_TEXT
                }
            })
        }
        } else if (action === "edit") {
            setMaterialAction("edit");
            setIsEditQuestionBank(true);
            setQsBankOpen(true);
            setIsUploadOpen(true);
            setSingleQuestionBankData(data);
        }
    }

    //To open upload popup
    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setQsBankOpen(true);
    };

    return (
        <div className={`QuestionBank ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={qsBankOpenCsv ? subCategory : 'Questions Bank'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={qsBankOpenCsv}
                onClose={handleCloseCsv}
                setOpen={setQsBankOpen}
                backNavigation={{ path: backNavigation, state: state }}
                demoFile={true}
            />
            {
                (qsBankOpenCsv) ?
                    <div className='QuestionBankView'>
                        <ViewPage data={qsBankCsvFileData} isQuestionBank={true}/>
                    </div>
                    :
                    <>
                        {
                            loading || AdminLoading ? <Loader bottom='165px' />
                                :
                                <div className='QuestionBankBody' style={{height: role === STUDENT_ROLE ? '100%':''}}>
                                    <QuestionBankList
                                        isQuestionBank={true}
                                        questionBankData={questionBankData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                        setRefetch={null}
                                    />
                                </div>
                        }
                        {(role !== STUDENT_ROLE)&& <div className='sampleDemoFileMobileContainer'>
                            <a  href={baseUrl + CLASSROOM_S3_PATH +'materials/QuestionsBankSample.csv'} download rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className='link'>
                                <img src={CloudDownload} alt="upload" className='downloadImage' />
                                <label className='demoFilename'>{`Sample csv`}</label>
                            </a>
                        </div>}
                        {role !== STUDENT_ROLE && <div className='libraryUploadButtonMobile' onClick={handleOpenUpload}>
                            <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>}
                    </>
            }
            {isUploadOpen && !isEditQuestionBank && <CommonBulkUpload page="Question bank" type='questionsBank' name={QUESTION_BANK_TEXT} setUploadedPayloads = {setUploadedPayloads} setFilesStatusData = {setFilesStatusData} setTotalProgress = {setTotalProgress} setSuccessCount = {setSuccessCount} setFailureCount = {setFailureCount} setUrl={setQsBankUrl} open={qsBankOpen} setOpen={setQsBankOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setQsBankFilename} setFileData={setQsBankFileData} setUploadFailed={setQsBankUploadFailed} setUploadProgress={setQsBankUploadProgress} setuploaded={setQsBankUploaded} setUploadFileName={setQsBankUploadFileName}/>}
            {isUploadOpen && isEditQuestionBank && singleQuestionBankData && <FileUpload page="Question bank" type='questionsBank' setHasSubmittedForEdit={setHasSubmittedForEdit} setMaterialAction={setMaterialAction} selectedFileData = {singleQuestionBankData} isEdit = {isEditQuestionBank} setIsEdit = {setIsEditQuestionBank} name={QUESTION_BANK_TEXT} setUrl={setQsBankUrl} open={qsBankOpen} setOpen={setQsBankOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setQsBankFilename} setFileData={setQsBankFileData} setUploadFailed={setQsBankUploadFailed} setUploadProgress={setQsBankUploadProgress} setuploaded={setQsBankUploaded} setUploadFileName={setQsBankUploadFileName}/>}
            {qsBankUploaded && <UploadToaster successCount = {successCount} failureCount={failureCount} FilesStatusData = {FilesStatusData} setFilesStatusData = {setFilesStatusData} totalProgress = {totalProgress} setTotalProgress = {setTotalProgress} uploaded={qsBankUploaded} setuploaded={setQsBankUploaded} uploadProgress={qsBankUploadProgress} setUploadProgress={setQsBankUploadProgress} fileName={qsBankUploadFileName} setUploadFileName={setQsBankUploadFileName} uploadFailed={qsBankUploadFailed} setUploadFailed={setQsBankUploadFailed} />}

            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='QnBankDirectClass'
            />
             {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !qsBankOpenCsv &&
                            <div className='libraryHeaderUploadContainer'> 
                             {(role !== STUDENT_ROLE  && getScreenDimensions().isMobileScreen)&& <div className='sampleContainer'>
                        <a  href={baseURL+'materials/QuestionsBankSample.csv'} download rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className='link'>
                            <img src={CloudDownload} alt="upload" className='downloadImage' />
                            <label className='demoFilename'>{`Sample csv`}</label>
                        </a>
                    </div>}
                                <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                               
                            </div>}
                            
        </div>
    )
}

export default QuestionBank;